export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "",
    "notifications.rp_has_been_updated": "आबासिय परियोजना अपडेट गरियो ।",
    "moduleTitle.files": "फाइलहरु",
    "label.coordinator": "सम्योजक",
    "sidebar.translations_managment": "",
    "table.file": "फाईल",
    "label.report_overview": "",
    "label.parent_agreement": "अभिभाबक र&#39;s सहमति",
    "parentalConsent.i_consent_to_and_understand_that": "६. म अनुमति दिन्छु र बुझ्दछु कि अवार्डको बिभिन्न क्रियाकलापमा भाग लिदा फोटो लिन सक्नु हुनेछ र सो फोटो अवार्डको प्रचारको लागि प्रयोग गर्न सकिने छ । यसको लागि सहभागी र अबिभावकले अनुमति पत्र मा हस्ताक्षर गर्नु पर्ने छ ।",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "१२. मलाइ थाहा छ कि सहभागीले रेकर्ड बुक वा ORB मा  भएको नीति नियमहरु अक्षरस पालना गर्नु आबस्यक छ साथै अवार्ड अपरेटरले विभिन्न समयमा जारि गरेको (समय समयमा परिमार्जन हुने ) नीति नियमहरु पालना गर्नु पर्दछ । अवार्ड युनिटले प्रदान गरेको आकस्मिक योजना सहयोगका क्रियाकलाप साथै सहासिक यात्रामा देखाउनु पर्ने बानी व्यहोरा पालन गर्नु पर्दछ । यसका लागि अवार्ड युनिट ले यी सबै नियम पालना नगरेमा अवार्ड स्वीकारोक्ति फिर्ता लिन सकिने छ ।",
    "table.end_date": "अन्तिम मिति",
    "label.activation_date": "सुरु गरिएको मिति",
    "label.report": "",
    "label.award_is_offline": "",
    "label.pending_changes": "परिबर्तन हुने क्रममा",
    "errors.min_nights_required": "",
    "label.country": "देश",
    "notifications.award_leader_has_been_returned": "अवार्ड लिडरलाई संसोधन गरिएको छ ।",
    "notifications.participant_has_been_updated": "सहभागीलाई अपडेट गरियो ।",
    "label.phone_number": "फोन नम्बर",
    "roles.aj_assessor": "साहसिक यात्राको निरीक्षक",
    "notifications.person_state_has_been_changed": "",
    "pageTitle.dashboard": "ड्यासबोर्ड",
    "moduleTitle.global_payment_method": "विश्व भुक्तानी तरिका",
    "label.organization_type": "संस्था  किसिम",
    "button.account_settings": "खाता सम्बन्धि सेटिंगहरु",
    "notifications.contact_has_been_updated": "सम्पर्क विवरण परिस्कृत गरियो ।",
    "participant.recover_password": "पासवोर्ड पुन प्राप्त गर्नुहोस",
    "notifications.assessment_request_has_been_sent": "मुल्यांकन का लागि अनुरोध पठाइएको छ ",
    "button.unassign": "",
    "label.start_date": "सुरु मिति",
    "label.assign_labels": "",
    "sidebar.participants": "सहभागीहरु",
    "roles.coordinator": "कोअर्डिनेटर",
    "label.organization_contact": "संस्थाको सम्पर्क नम्बर ",
    "tabs.customization": "अनुकूलन",
    "sidebar.award_units": "अवार्ड युनिटहरु",
    "button.change_goal": "लक्ष परिवर्तन गर्नुहोस",
    "translationsManagement.selectProject": "",
    "award.rp": "आबासिय परियोजना",
    "label.size": "",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "क्रियाकलाप स्वीकृत भएको छ ।",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "पुन पठाउन अनुरोध ",
    "notifications.template_has_been_removed": "टेम्प्लेट हटाइएको छ",
    "button.award_settings": "अवार्ड सेटिंग",
    "pageTitle.payment": "भुक्तानी",
    "tasks.return_award": "संसोधित अवार्ड",
    "label.link": "",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "मेरो रिजनल अफिस  - सम्बन्धित सम्पर्क विवरणहरु ",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "यो भाग प्रमाणित भयो",
    "table.logs": "लगहरु",
    "moduleTitle.remove_file": "के फाइल हटाउन चाहनुहुन्छ",
    "label.email_confirmed": "इमेल पुष्टि भयो ",
    "notifications.activity_has_been_returned": "क्रियाकलाप संसोधन गरिएको छ ।",
    "label.note": "नोट",
    "button.show": "",
    "tabs.adventurous_journey": "साहासिक यात्रा",
    "sidebar.my_todolist": "",
    "label.here": "",
    "organisation.change_award_mode": "",
    "table.note_from_al": "सबैको लागि नोट",
    "label.gender": "लिङ्ग",
    "moduleTitle.remove": "मेटाउन चाहानुहुन्छ ?",
    "errors.must_be_less_than": "",
    "button.logout": "लग आउट",
    "label.no_selected_participants": "",
    "button.new_aj_event": "नयाँ सहासिक यात्रा विवरण",
    "label.employement_status": "रोजगरिको अवस्था",
    "tabs.logs": "लग",
    "tabs.contacts": "सम्पर्क",
    "label.option": "विकल्प ",
    "dashboard.charts": "तलिकाहरु",
    "notifications.rp_has_been_approved": "आबासिय परियोजना स्वीकृत भयो ।",
    "pageTitle.new_participant": "नयाँ  सहभागी",
    "notifications.award_leader_has_been_approved": "अवार्ड लिडर स्वीकृत भएको छ ।",
    "moduleTitle.would_you_like_to_remove_leader_training": "के तपाइँ अवार्ड लिडरको तलिमलाई हटाउन चाहनुहुन्छ ?",
    "moduleTitle.update_configuration_value": "कन्फिगरेसन अद्यावधिक गर्नुहोस",
    "table.description": "विवरण",
    "table.organization": "सस्था",
    "label.youtube": "युट्युब",
    "label.author": "",
    "table.suitable_for_award_level": "अवार्ड तहको लागि योग्य",
    "label.content_update": "कृपया पर्खनुस । विवरण अपडेट हुदै छ ।",
    "notifications.new_question_has_been_added": "नयाँ प्रस्न थपिएको छ ",
    "pageTitle.nao_awards": "नेसनल अफिस - अवार्डहरु",
    "table.last_name": "अन्तिम नाम",
    "moduleTitle.adventurous_journey_detail": "",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "परियोजना स्थलको प्रकार",
    "label.email_help_award_level": "",
    "label.date": "मिति",
    "label.previous_completed_award_place": "कहाँ",
    "button.show_more": "अरु हेर्नुहोस",
    "label.wwc_number": "",
    "button.filter": "छान्नुहोस",
    "notifications.rp_has_been_returned": "आबासिय परियोजना संसोधन भएको छ ।",
    "pageTitle.residetial_project_assessor_report": "आबासिय परियोजना - निरिक्षकको रिपोर्ट",
    "label.generating": "",
    "moduleTitle.finance_system_data": "",
    "notifications.adventurous_journey_state_has_been_changed": "साहसिक यात्राको अबस्था परिबर्तन भयो",
    "route.levels": "तहहरु",
    "moduleTitle.activity_leader": "क्रियाकलाप लिडर",
    "tasks.approve_event": "स्वीकृत गतिबिधि",
    "tasks.reject_event": "संसोधित गतिबिधि",
    "table.region": "क्षेत्र",
    "pageTitle.nao_award_leaders": "नेसनल अफिस - अवार्ड लिडरहरु",
    "errors.must_be_at_least": "कम्तिमा  {min}  बर्ण आवस्यक",
    "table.title": "शीर्षक",
    "table.last_activity": "अन्तिम क्रियाकलाप",
    "tasks.delete_registration": "रजिस्ट्रेशन मेटाउनुहोस",
    "table.date_time": "",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "१४. अवार्ड अपरेटर तपाइको व्यक्तिगत मामलाको आदर गर्दछ ।तपाईको व्यक्तिगत जानकारी अवार्डमा सहभागी हुनको लागि मात्र संकलन गरीएको हो  सहभागीले यो सम्पूर्ण जानकारी प्रदान नगरेसम्म अवार्डमा सहभागी हुन सक्ने छैनन् ( याद गर्नुहोस यो जानकारी अनाबस्यक ठाउँमा प्रयोग हुने छैन ) हामी तपाइको व्यक्तिगत जानकारी अवार्ड संग सम्बन्धित अन्य क्रियाकलाप जुन तपाईलाई मन पर्न सक्छ , त्यस्ता क्रियाकलापमा भने प्रयोग गर्न सकिने छ । हामीलाई अवार्ड संचालन गर्न सहयोग गर्ने राष्ट्रिय तथा अन्तराष्ट्रिय सस्थाहरुलाई जानकारि प्रदान गर्न सक्ने छौ ।यदि तपाइँ आफ्नो व्यक्तिगत जानकारी  लिन चाहानुहुन्छ भने अवार्ड अपरेटर संग सम्पर्क गर्नु होला ।तपाइले आफ्नो अवार्ड अपरेटरसंग Privacy Policy को प्रतिलिपि  समेत लिन सक्नु हुनेछ ।",
    "aj.practice_journey": "अभ्यास यात्रा",
    "notification.log_has_been_restored": "",
    "tabs.my_participants": "मेरा सहभागीहरु",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "पर्यबेक्षक",
    "moduleTitle.your_parental_consent": "तपाइको अभिभाबकको सहमति",
    "route.registration_participants": "सहभागी दर्ता",
    "placeholder.start_typing": "लेख्न सुरु गर्नुहोस",
    "tasks.approve_award": "स्वीकृत अवार्ड",
    "route.registrations": "रजिस्ट्रेशनहरु ",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "साहासिक यात्रा सम्बन्धि गतिबिधिहरु सिर्जना गरिएको छ  ।",
    "states.supervisor_approval": "",
    "label.description": "विवरण",
    "button.leave_anyway": "ठिकै छ बाहिरिन्छु",
    "tabs.registrations": "रजिस्ट्रेसनहरु ",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "नेसनल अफिस - दर्ता",
    "pageTitle.mro_logs": "मेरो रिजनल अफिस  - लगहरु",
    "meta.page_not_found": "पेज भेटिएन ",
    "label.bulk_action_unsuccessful": "",
    "global.days": "दिनहरु",
    "table.review": "लगहरु",
    "table.as_assessor_for": "",
    "roles.if_staff_statistical_user": "",
    "table.levels": "तहहरु",
    "label.suitable_for_level": "यो तहका लागि उपर्युक्त",
    "pageTitle.leaders": "लिडहरु",
    "moduleTitle.send_test_email": "",
    "pageTitle.tasks_removed_registration": "",
    "label.you_will_be_forced_to_login_again_after_change": "",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "यो भाग प्रमाणित भयो",
    "pageTitle.payments": "भुक्तानीहरु",
    "global.nights": "रातहरु",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "सस्था छान्नुहोस्",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "",
    "label.migrated_contact_email": "सारिएको इमेल ठेगाना",
    "label.for_award_unit": "अवार्ड युनिटका लागि",
    "label.aj_template_note": "टेम्प्लेट नोट",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "कृपया सहभागीको सुधार / प्रदर्शन / प्रतिबद्धता बारेमा कमेन्ट गर्नुहोस ।",
    "label.consent_already_given_login": "",
    "participant.level_start_date": "{value} सुरु मिति",
    "sidebar.my_region_office": "मेरो रिजनल अफिस",
    "states.section_signoff": "यो भाग प्रमाणित भयो",
    "moduleTitle.assessor_details": "",
    "moduleTitle.adventurous_journey_settings": "साहसिक यात्रा सबन्धि सेटिंगहरु",
    "moduleTitle.note_from_al": "अवार्ड लिडरको लागि नोट",
    "button.add_role": "भूमिका थप्नुहोस ",
    "table.run": "दौडनु",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "अवार्ड लिडरका लागि app प्रयोग गर्ने गाइड",
    "tabs.section_approval": "यो भाग प्रमाणित भयो",
    "roles.award_verifier": "अवार्ड प्रमाणित गर्ने",
    "tabs.activity_approval": "क्रियाकलप अनुमोदन",
    "logs.add_log": "लग थप्नुहोस",
    "tabs.award": "अवार्ड",
    "notifications.this_role_has_read_only_persmission": "",
    "table.no_filtered_results": "छानीएको नतिजा भेटिएन",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "स्थानको विस्तृत विवरण",
    "label.optional": "(बैकल्पिक )",
    "errors.do_not_match": "समान भएन",
    "label.use_comma_for_multiple_entries": "",
    "label.operating_authority": "संचालक अख्तियार प्राप्त संस्था",
    "label.activity_section": "क्रियाकलाप खण्ड ",
    "notifications.you_have_been_logged_out": "तपाईं लग आउट हुनुभयो ।",
    "table.finished": "पुरा भयो",
    "button.same_as_billing": "बिल अनुसार ठिक छ",
    "table.payment": "भुक्तानी",
    "table.current_level": "अहिलेको तह",
    "button.view_nao": "",
    "table.email_confirmation": "इमेलबाट पुष्टि गर्नुहोस",
    "moduleTitle.shipping_address": "ढुवानी ठेगाना",
    "label.secondary_phone_type": "",
    "notifications.saved": "सेभ भयो ।",
    "pageTitle.all_participants": "सम्पूर्ण सहभागीहरु",
    "label.first_name": "पहिलो नाम",
    "label.oa_price": "OA शुल्क",
    "table.award_mode": "",
    "tabs.api_keys": "",
    "award.award_detail": "अवार्डको विवरण",
    "tabs.user_management": "प्रयोगकर्ता व्यवस्थापन गर्नुहोस",
    "tabs.all_events": "सम्पूर्ण गतिबिधि",
    "notifications.history_record_has_been_removed": "",
    "award.no_data": "नयाँ तथ्यांक",
    "notifications.preparation_training_has_been_added": "तयारी र तालिम थपियो",
    "label.message": "",
    "notifications.participant_info_updated": "",
    "roles.nao_staff": "NAO कर्मचारी",
    "tabs.adventurous_journeys": "सहासिक यात्रा",
    "label.gops": "",
    "route.upload": "अपलोड",
    "notifications.history_record_has_been_added": "",
    "notifications.history_record_has_been_updated": "",
    "label.no_data": "कुनै तथ्यांक छैन",
    "button.add_coordinator": "संयोजक थप्नुहोस",
    "label.you_are_already_logged_as": "तपाईं ␣ को रुप मा लग भैसक्नु भएको छ ।",
    "route.my_national_office": "मेरो नेसनल अफिस",
    "tabs.leaders": "लिडरहरु",
    "label.email_confirmation": "इमेल मार्फत कन्फर्म गर्नुहोस",
    "table.registration_date": "दर्ता मिति",
    "notifications.role_has_been_removed": "भूमिकालाई हटाइयो",
    "button.move": "",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "विस्तृत विवरण",
    "table.award_unit": "अवार्ड इकाई",
    "sidebar.settings": "सेटिंग",
    "dashboard.leader_state": "लिडरहरु - क्षेत्रको आधारमा",
    "notifications.award_unit_has_been_approved": "अवार्ड लिडरलाई  अनुमोदन गरिएको छ ।",
    "states.awaiting_approval": "अनुमोदनको पर्खाइमा",
    "table.level": "तह",
    "table.action_requested": "",
    "label.organisation_mode": "",
    "label.no_note": "कुनै नोट छैन",
    "tabs.my_events": "मेरो गतिबिधि",
    "notifications.participants_have_been_added": "सहभागीहरुलाई सामेल गरिएको छ ।",
    "tabs.registration_questions": "",
    "button.delete_registration": "रजिस्ट्रेसन मेटाउनुहोस",
    "notifications.parental_consent_link_has_been_sent": "",
    "moduleTitle.select_role_organization": "भूमिका रा सस्था छान्नुहोस्",
    "label.experience": "",
    "translationsManagement.modal.title": "",
    "table.ic": "IC",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "के तपाइँ यो खाता मेटाउन चाहानुहुन्छ",
    "table.fields_included": "",
    "label.user_guide_web_leader": "प्रयोगकर्ता वेब पुस्तिका - अवार्ड लिडर",
    "label.journey_type": "यात्राको प्रकार",
    "button.setup": "सेटअप",
    "tabs.my_national_office": "मेरो नेसनल अफिस",
    "notifications.training_has_been_removed": "तालिमलाई हटाइयो ।",
    "label.nominated_and_identified_persons": "मनोनित र परिचित व्यक्तिले सबै तथ्यहरु हेर्न सक्नेछन तर सम्पादन गर्न सक्ने छैनन् ।",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "निस्क्रियाताको कारण तपाईं क्रियाकलापबाट बाहिरिनु भएको छ",
    "states.award_leader_signoff": "अवार्ड लिडरले प्रमाणित गर्नुभयो",
    "table.award_signoff_attempts": "पुरस्कार हस्ताक्षर प्रयासहरू",
    "sidebar.regions": "क्षेत्र",
    "label.activity_deleted_note": "यो क्रियाकलाप मेटाइएको छ । तपाईं तलको बटन क्लिक गरेर फेरी पुनस्थापना गर्न सक्नुहुन्छ ।",
    "table.total": "जम्मा",
    "errors.a_problem_has_occured_during_processing": "",
    "participant.participant_already_has_gold_award": "",
    "pageTitle.mro": "मेरो रिजनल कार्यालय",
    "notifications.authorization_code_has_expired": "",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "साहसिक यात्राका गतिबिधिहरु",
    "global.loading": "लोड हुदै ...",
    "label.gnipp": "",
    "sidebar.registrations": "दर्ताहरु",
    "label.any_string": "कुनै  स्ट्रिंग",
    "contact.change_contact_status": "",
    "tabs.registration": "दर्ता गर्नुहोस",
    "label.override_payment_note": "अधिलेखन भुक्तानी टिप्पणी",
    "notifications.section_has_been_signed_off": "यो भाग प्रमाणित भयो ।",
    "label.payment_date": "भुक्तानी मिति",
    "button.approve": "अनुमोदन गर्नुहोस",
    "moduleTitle.loggin_in": "",
    "label.website": "वेबसाइट",
    "label.role": "भूमिका",
    "table.assessor_report": "निरीक्षकको रिपोर्ट",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "",
    "pageTitle.registrations": "रजिस्ट्रेसन",
    "parentalConsent.this_form_must_be_completed": "यो फम  <strong>must</strong> १८ वर्ष मुनिका  <strong> सहभागीका अभिभाबकले भर्न जरुरि छ ।",
    "button.apply": "",
    "errors.include_at_least_one_number": "कम्तिमा एउटा नम्बर समाबेस गर्नुहोस",
    "label.content_restore": "",
    "logs.hour": "घण्टा",
    "parentalConsent.i_have_read_and_understand": "७. अवार्डमा उल्लेख भए बमोजिम मैले अवार्डको विभिन्न तह यिनको आबस्यकता पढेको र बुझेको छु ।",
    "notifications.award_was_deleted": "",
    "label.journey_category": "यात्राको किसिम",
    "notifications.search_cancelled": "",
    "route.detail": "विस्तृत विवरण",
    "route.user_guide": "प्रयोगकर्ता पुस्तिका",
    "moduleTitle.history": "",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "मुल्यांकन नगरिएका सहभागीहरु",
    "states.inactive": "सक्रिय छै",
    "pageTitle.search_results": "",
    "button.proceed_to_login": "",
    "pageTitle.assessor_report_reject": "निरीक्षकको रिपोर्ट पुनःमुल्यांकन",
    "notifications.contact_has_been_removed": "सम्पर्क विवरण हटाइयो ।",
    "sidebar.operating_authorities": "संचालक अख्तियार प्राप्त संस्था",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "तयारी र तालिम",
    "route.user_guide_web_leader": "प्रयोगकर्ता वेब पुस्तिका - अवार्ड लिडर",
    "label.position_in_organization": "संस्थामा  स्थिति",
    "errors.emails_dont_match": "इमेल समान भएन",
    "route.my_participants": "मेरा सहभागीहरु",
    "pageTitle.customisations": "अनुकूलन",
    "tabs.localization_files": "फाइललाई स्थानीय स्तर मा राखिएको छ",
    "table.assessor_approval": "निरिक्षकको अनुमोदन",
    "tabs.related_contacts": "सम्बन्धित सम्पर्क ठेगाना",
    "table.aus": "अवार्ड युनिट",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "सम्भावित तथ्य ",
    "label.if_your_download_doesnt_start": "",
    "route.independent_award_centres": "",
    "pageTitle.user_guide": "प्रयोगकर्ता पुस्तिका",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "मेरो संस्था - विवरण",
    "pageTitle.nao_detail": "नेसनल अफिस - विस्तृत विवरण",
    "button.change": "परिबर्तन गर्नुहोस",
    "award.aj": "साहसिक यात्रा",
    "table.award_state": "अवार्डको तह ",
    "pageTitle.tasks_award_signoff": "अवार्ड प्रमाणित भयो",
    "pageTitle.regions": "क्षेत्रहरु",
    "notifications.award_has_been_signed_off": "अवार्ड प्रमाणित भएको छ ।",
    "dashboard.award_approved_by": "स्वीकृत अवार्डहरु - २०१६ सम्ममा",
    "tabs.new_template": "नयाँ  टेम्पलेट",
    "error.parent_email_must_be_filled": "",
    "label.organisation_invoicing_name": "",
    "pageTitle.related_contacts": "सम्बन्धित सम्पर्क बिबरण",
    "button.try_again": "चेतावनी बन्द गर्नुहोस र फेरी कोसिस गर्नुहोस",
    "label.cannot_be_change_to_another": "",
    "notifications.lead_coordinator_has_been_set": "",
    "label.training_name": "तलिमको नाम",
    "moduleTitle.new_contact": "नयाँ सम्पर्क विवरण थप्नुहोस",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "",
    "notifications.award_level_has_been_changed": "अवार्ड को तह परिवर्तन गरिएको छ ।",
    "label.subject": "",
    "route.silver_level": "सिल्भर तह",
    "label.privacy_notice": "",
    "label.switch_organization": "सस्था परिबर्तन गर्नुहोस ।",
    "meta.dofe_name": "The Duke of Edinburgh’s Award",
    "route.profile": "प्रोफाइल",
    "roles.super_user": "एकदम राम्रो प्रयोगकर्ता",
    "dashboard.while_you_were_gone": "कहा जादै हुनुनुहुन्छ",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "बिचको नाम",
    "moduleTitle.new_activity": "नया क्रियाकलाप",
    "organisation.would_you_like_to_remove": "",
    "label.state_province": "अंचल",
    "moduleTitle.your_home_address": "तपाईंको घरको ठेगाना",
    "tabs.sign_offs": "साइन अफ भयो",
    "moduleTitle.logs": "लगहरु",
    "button.view_more": "",
    "label.profile": "प्रोफाइल",
    "label.title": "शिर्षक",
    "tabs.award_signoff": "अवार्ड प्रमाणित भयो",
    "label.post_code": "पोस्ट कोड",
    "states.ceremony_certificate": "कार्यक्रम र प्रमाण पत्र",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "अवार्ड अपरेटर वा अवार्ड युनिटलाई प्रदान गरेका व्यक्तिगत जानकारीहरु ( सहभागी जानकारी सहित ) अवार्डको प्रकियामा प्रयोग गर्नको लागि म अनुमति दिन्छु र यो जानकारी नेपाल सरकारको नियम  बमोजिम प्रयोग गर्नको लागि स्वीकारोक्ति ब्यक्त गर्दछु ।",
    "label.user_guide_web_participant": "प्रयोगकर्ता वेब पुस्तिका - सहभागी",
    "label.award_unit_type": "अवार्ड इकाईको प्रकार",
    "states.complete": "",
    "table.participant_state": "सहभागीको तह ",
    "pageTitle.my_organization_payment": "मेरो संस्था - भुक्तानी",
    "table.approved": "स्वीकृत",
    "pageTitle.my_organization_contacts": "मेरो संस्था  - सम्पर्क ठेगाना",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "एसलाई <strong>{state}</strong> मा परिवर्तन गर्नुहोस ।",
    "label.integer": "इंतिजर",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "पासवोर्ड परिबर्तन भयो",
    "button.invite_assessor": "",
    "label.other_activity": "अन्य क्रियाकलाप",
    "notifications.parental_consent_has_been_sent": "अभिभावकको स्वीकृतिका लागि पठाइएको छ ।",
    "button.revise": "संशोधन गर्नुहोस",
    "errors.end_date_must_be_after_start_date": "",
    "label.award_leader_signoff_date": "",
    "parentalConsent.i_understand_every_participant_must": "८. मैले यो पनि बुजेको छु कि सहभागीले अवार्ड युनिट मार्फत अवार्डमा सहभागी जसलाई पनि अवार्डका लागि स्वीकार वा अस्विकार गर्ने अनुमति छ ।",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "साहसिक यात्रा",
    "global.day": "दिन",
    "moduleTitle.coordinator": "सयोजक",
    "label.region": "क्षेत्र ",
    "button.add_history_record": "",
    "moduleTitle.adventurous_journey_template_settings": "साहसिक यात्राको टेम्प्लेट सम्बधि सेटिंग",
    "notifications.personal_details_have_been_updated": "ब्यक्तिगत विवरण अपडेट गरियो ।",
    "sidebar.ics": "ICs",
    "table.independent_award_centre": "",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "अभिभाबकको सहमति",
    "label.photo_consent_given": "",
    "moduleTitle.authorising_contact": "आधिकारिक सम्पर्क",
    "label.assessment_with_role": "",
    "dashboard.type_of_awards": "अवार्ड युनिटको प्रकार",
    "moduleTitle.payment": "भुक्तानी",
    "states.in_progress": "प्रकियामा छ",
    "logs.no_logs": "लगहरु उपलब्ध छैन",
    "sidebar.my_office": "मेरो कार्यालय",
    "label.assessor_report": "निरीक्षकको रिपोर्ट",
    "notifications.rp_has_been_signed_off": "सहासिक यात्रा प्रमाणित भएको छ ।",
    "tabs.labels": "",
    "sidebar.payments": "भुक्तानिहरु",
    "meta.profile_questions": "प्रोफाइल प्रस्नहरु ",
    "label.fax": "Fax",
    "label.email_help_custom_link": "",
    "label.last_name": "अन्तिम नाम",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "सहभागीहरु - तहको आधारमा",
    "tabs.award_leaders": "अवार्ड लिडरहरु",
    "label.i_confirm_that_ive_witnessed": "",
    "table.lead_coordinator": "",
    "states.deleted": "मेटाइएको",
    "label.no_answers": "",
    "button.add": "थप्नुहोस",
    "label.exchequer_number": "",
    "label.waiting": "पर्खनुहोस",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "दर्ता संसोधन भयो",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "अभिभाबकको स्वीकृति",
    "table.assessor_approve": "निरीक्षकको अनुमोदन",
    "errors.some_fields_requires_your_attention": "केहि क्षेत्रहरुमा तपाईं को ध्यान जानु आबस्यक छ ।",
    "aj.qualifying_journey": "क्वालिफाइङ यात्रा",
    "route.awards": "अवार्डहरु",
    "table.registration": "दर्ता",
    "pageTitle.assessors": "",
    "notifications.award_has_been_updated": "अवार्ड अपडेट भयो ।",
    "errors.must_be_one_of": "{enums} यी मध्ये कुनै एक अनुबार्य ",
    "pageTitle.logs": "लगहरु",
    "notifications.notifications.invitation_has_been_sent": "",
    "route.national_offices": "नेसनल अफिसहरु",
    "notifications.training_has_been_updated": "तालिम अपडेट गरियो ।",
    "label.parent_last_name": "अभिभाबकको अन्तिम नाम",
    "table.leaders": "लिडरहरु",
    "states.award_level_complete": "अवार्ड तह पुरा",
    "button.reset": "पुनः सेट गर्नुहोस",
    "sidebar.my_award_unit": "मेरो अवार्ड इकाई",
    "pageTitle.all_aj_events": "साहसिक यात्राका सम्पूर्ण कार्यक्रमहरु",
    "label.activity": "क्रियाकलाप",
    "moduleTitle.are_you_sure": "पक्का हो  ?",
    "route.gold_level": "गोल्ड तह",
    "table.evidence": "प्रमाण",
    "label.delivery_confirmed": "पुगेको निश्चित भयो",
    "parentalConsent.as_the_parent": "अभिभावकको / संरक्षकको रूपमा, म कुनै पनि फोटो  प्रचार प्रसार  गर्ने  उद्देश्यकालागि  प्रयोग गर्नका लागि सहमति दिन्छु ।",
    "label.awardMode.offline": "",
    "tasks.approve_registration": "रजिस्ट्रेशन प्रमाणित",
    "note.change_the_email_will_change": "नोट इमेल परिवार्नता गर्दा सारिएको इमेल ठेगाना पनि परिवर्तन हुन्छ ।",
    "notifications.participant_has_been_approved": "सहभागीलाई स्वीकृत गरियो ।",
    "label.reached_activity_limit": "यो  खण्डमा क्रियाकलापको सिमा पुरा भएको छ । प्रतेक खण्डमा सहभागीले बढीमा  ३ वटा क्रियाकलाप छान्न सक्नुहुन्छ ।",
    "label.facebook": "फेसबूक",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "तयारी र तालिम हटाइयो",
    "pageTitle.settings": "सेटिंग",
    "participant.level_registration_date": "दर्ता मिति {value}",
    "notifications.question_has_been_removed": "प्रस्न हटाइएको छ ",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "लिडरहरु",
    "notifications.participants_have_been_transferred": "सहभागीलाइ ट्रान्सफर गरिएको छ ",
    "tabs.assessors": "",
    "sidebar.dashboard": "ड्यासबोर्ड",
    "pageTitle.independent_award_centers": "स्वतन्त्र अवार्ड सेन्टरहरु",
    "label.search": "खोज्नुहोस",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "सहभागीको नोट",
    "errors.required_field": "आबस्यक खण्ड",
    "tasks.approve_task": "स्वीकृत कार्य",
    "logs.edit_log": "लग सम्पादन गर्नुहोस",
    "table.state": "राज्य",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "रद्द गर्नुहोस ",
    "label.parent_first_name": "अभिभाबकको पहिलो नाम",
    "parentalConsent.i_understand_that_the_participant": "१.मलाई थाहा छ, यो फर्म पुरा नगरेसम्म सहभागीले अवार्ड कार्यक्रममा सहभागी हुन सक्ने छैन ( जसमा अबिभाबकाको सहमति आबस्यक  छ ) र सम्बन्धित अवार्ड संचालकको मा आउँन आबस्यक छ यसको साथमा दर्ता  शुल्क पनि बुझाउनु पर्दछ जुन अवार्ड युनिटले स्वीकार गर्नु पर्छ ।",
    "tabs.award_units": "अवार्ड इकाईहरु",
    "table.hours": "घण्टाहरु",
    "label.type": "प्रकार",
    "notifications.adventurous_journey_has_been_removed": "साहसिक यात्रा हटाइयो",
    "label.aj_is_not_approved_yet": "",
    "roles.authorizing_contact": "आधिकारिक सम्पर्क",
    "table.date_submitted_to_office_signoff": "प्रमाणिकरणक लागि अवार्ड अफिस मा बुझाइएको मिति",
    "notifications.section_has_been_returned": "यो भाग संशोधन गरिएको छ ।",
    "table.created_by": "सिर्जना गर्ने व्यक्ति",
    "route.user_guide_web_participant": "प्रयोगकर्ता वेब पुस्तिका - सहभागी",
    "route.templates": "टेम्प्लेटहरु",
    "states.awaiting_sign_off": "अवार्ड लिडर ले प्रमाणित गर्नुभयो",
    "table.phone": "फोन",
    "label.parental_consent": "",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "ब्रोंन्ज तह",
    "label.invoice_currency": "",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "",
    "notifications.contact_has_been_created": "सम्पर्क विवरण सिर्जना गरियो ।",
    "pageTitle.profile_questions": "प्रोफाइल प्रस्नहरु",
    "table.observation_files": "अबलोकन फाइलहरु",
    "table.participants": "सहभागीहरु",
    "tasks.no_evidence": "प्रमाण उपलब्ध भएको छैन ।",
    "button.edit": "पुष्टि गर्नुहोस",
    "moduleTitle.leader": "लिडर",
    "notifications.new_template_has_been_updated": "नया टेम्पलेटलाई अपडेट गरिएको छ ।",
    "table.name": "नाम",
    "label.no_results": "नतिजा भेटिएन",
    "moduleTitle.documents": "",
    "button.invite": "",
    "label.goal": "लक्ष्य",
    "pageTitle.nao_award_units": "नेसनल अफिस - अवार्ड युनिटहरु",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "कम्तिमा {length} बर्ण आबस्यक",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "भूमिका हटाउने हो ?",
    "label.total": "जम्मा",
    "label.delete_participant_award_info": "",
    "route.leaders": "लिडरहरु",
    "table.start_date": "सुरु मिति",
    "moduleTitle.coordinators": "संयोजकहरु",
    "button.create": "सिर्जना  गर्नुहोस",
    "tabs.awards": "अवार्डहरु",
    "parentalConsent.form_has_been_sent": "अभिबबकको स्वीकृति पठाइयो  ।",
    "states.journey_approval": "यात्रा अनुमोदन",
    "pageTitle.reports": "प्रगति विवरण",
    "table.journey_type": "यात्राको प्रकार",
    "label.yes": "हो",
    "pageTitle.assessor_report": "निरीक्षकको रिपोर्ट",
    "label.organization": "सस्था",
    "notifications.award_leader_has_been_updated": "अवार्ड लिडरलाई अपडेट गरियो",
    "moduleTitle.edit_role": "भूमिका सम्पादन गर्नुहोस /",
    "table.journey_activity": "यात्राको क्रियाकलाप",
    "label.location": "स्थान",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "",
    "global.assessor": "निरीक्षक",
    "moduleTitle.profile_questions": "प्रोफाइल प्रस्नहरु",
    "activity.cannot_edit_activity_if_award_in_state": "यदी अवार्ड {state} मा छ भने परिवर्तन गर्न सम्भव छैन ।",
    "moduleTitle.assessor_detail": "निरीक्षकको विवरण",
    "parentalConsent.i_understand_that_upon_acceptance_into": "१०.मलाई थाहा छ कि अवार्ड इकाईले मेरो सहभागिता स्वीकार गरेपछि मैले रेकर्ड बुक वा अनलाईन रेकर्ड बुकको सुबिधा पाउने छु । त्यसपछि  सहभागीले अवार्ड सुरु हुनु अगाबै अवार्ड डायरी वा अनलाइन रेकर्ड बुक मार्फत  सम्बन्धित जानकारी अध्यन गर्नु पर्ने छ ।मलाइ थाहा छ कि अवार्ड इकाईलाई ब्रोंज,सिल्भर र गोल्ड अवार्ड प्रदान गर्ने या नगर्ने निर्णय गर्ने  अधिकार छ । मैले यो पनि बुझेको छु कि अवार्ड अपरेटर संग कुनै पनि बिमा को नियम नहुन सक्छा साथै कथंकदाचित केहि भयको खण्डमा सहभागी आफैले बेहोर्नु पर्ने हुन्छ।",
    "notifications.award_has_been_returned": "अवार्ड संशोधन भएको छ ।",
    "label.code_of_conduct": "",
    "button.new_contact": "नया सम्पर्क",
    "tabs.payments": "भुक्तानी",
    "roles.naa_oa_staff": "",
    "label.switch_organisation_hint": "",
    "label.expiration_date": "",
    "tabs.participants": "सहभागीहरु",
    "table.practice": "अभ्यास",
    "notifications.one_activity_has_to_remain": "क्रियाकलापको कम्तिमा एउटा भाग मेटाउन सकिदैन ।",
    "label.qualifications": "",
    "states.organization_approval": "संस्था अनुमोदन",
    "errors.must_be_an_integer": "एउटा अंक अनिबार्य हुनुपर्ने छ",
    "participant.send_confirmation_email_again_question": "पुष्टि गर्ने इमेल पुन पठाउनु पर्ने हो ?",
    "button.dismiss": "खारेज गर्नुहोस",
    "table.advice": "",
    "label.years_of_working_experience": "",
    "notifications.search_failed": "",
    "notifications.changes_have_been_saved": "",
    "moduleTitle.resend_parental_consent_link": "",
    "label.activity_type": "क्रियाकलापको किसिम",
    "label.change_award": "अवार्ड को तह परिवर्तन गर्नुहोस",
    "label.email": "इमेल",
    "button.remove": "हटाउनुहोस",
    "button.download": "डाउनलोड",
    "label.vat_treatment": "",
    "pageTitle.aj_template_new": "नयाँ साहासिक यात्राको टेम्पलेट",
    "table.per_page": "प्रति पेज",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "",
    "tasks.revise_item": "संसोधित बस्तु",
    "button.resend_parental_consent": "",
    "table.weeks_completed_required": "पुरा भएको / सकीएको हप्ताहरु",
    "label.last_modified": "",
    "table.major": "मुख्य",
    "label.vat_number": "",
    "errors.passwords_dont_match": "पासवर्ड समान भएन",
    "table.country": "देश",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "प्रस्न सच्च्याइएको छ ",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "आधिकारिक कोड अब मान्य हुदैन ।",
    "errors.must_be_no_more_than": "बढीमा {min}  बर्ण आवस्यक",
    "notifications.event_has_been_rejected": "गतिविधिहरु परिमार्जन भएको छ ।",
    "tabs.customizations": "अनुकूलन",
    "label.name_organization": "नाम",
    "button.add_log": "लग थप्नुहोस ",
    "moduleTitle.invite_assessor": "",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "सबै सहभागीहरुलाइ नयां अवार्ड लिडर को मा पठाइने छ ",
    "label.repeat_email": "इमेल दोहोर्याउनु होस",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "भूमिका अपडेट भयो",
    "roles.if_staff_stat_user": "",
    "participant.delete_account": "खाता मेटाउनुहोस्",
    "moduleTitle.would_you_like_to_remove_this_log": "के तपाइँ लगलाई हटाउन चाहानु हुन्छ ?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "यात्राको किसिम ",
    "sidebar.manual_data_import": "",
    "label.created_after_date": "",
    "route.my_organization": "मेरो संस्था",
    "button.show_list": "",
    "label.leaders": "लिडरहरु",
    "notifications.log_has_been_modified": "लग मोडिफाई गरिएको छ ।",
    "button.upload_file": "",
    "moduleTitle.which_section_do_you_want_to": "तपाईं कुन सेक्शनमा फर्कन चांहनु हुन्छ ?",
    "tabs.bronze_level": "ब्रोंज तह",
    "notifications.participants_have_been_saved": "सहभागीलाई सुरक्षित गरियो ।",
    "pageTitle.aj_template_detail": "साहसिक यात्रा",
    "label.parent_email": "अभिभाबकको&#39;s इमेल",
    "map.appr_location": "मिल्दोजुल्दो  ठेगाना",
    "notifications.log_has_been_removed": "लगहरु मेटाइयो",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "रहन्छु",
    "table.previous_level": "अधिल्लो  तह",
    "label.award_start_date": "",
    "assessor_report.returned_to_participant": "सहभागी मै फर्कनुहोस",
    "pageTitle.tasks_assessors_registration": "",
    "aj.cannot_modify_award": "यदी सहासिक यात्राको  लागि सहभागी तोकिसकिएको भए सहभागीले आफ्नो अवार्ड लेबल परिवर्तन गर्न सक्नुहुन्न  ।",
    "moduleTitle.lost_internet_connection": "तपाईंको इन्टरनेट बन्द भए जस्तो छ ।",
    "states.ceremony": "कार्यक्रम",
    "participant.reactivate_account": "खाता सुरु गर्नुहोस",
    "label.birthdate": "जन्म मिति",
    "pageTitle.assessment_send_successfully": "मुल्यांकन सफलता पुर्बक पठाइएको छ ",
    "states.assessor_approval": "निरीक्षकको अनुमोदन",
    "award.change_award_level": "अवार्डको तह परिवर्तन गर्नुहोस ।",
    "label.url_no_longer_valid": "",
    "button.update": "अपडेट",
    "label.secondary_email": "",
    "button.role_edit": "सम्पादन",
    "table.award_leader": "",
    "label.level": "तह",
    "tasks.evidence": "प्रमाण",
    "notifications.participant_is_already_in_list": "",
    "button.clear": "मेटाउनुहोस",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "सेटअप",
    "table.activity": "क्रियाकालप",
    "label.copy_to_clipboard": "",
    "route.award_units": "अवार्ड युनिटहरु",
    "button.upload_photo": "तस्बिर राख्नुहोस ",
    "table.hours_completed_required": "पुराभएको  / आबस्यक घण्टा",
    "table.first_name": "पहिलो नाम",
    "notifications.adventurous_journey_has_been_returned": "साहसिक यात्रा संसोधन भयो ।",
    "pageTitle.national_offices": "नेसनल अफिस",
    "notifications.you_have_been_logged_in": "तपाईं ले लग इन गर्नुभएको छ ।",
    "logs.offline": "",
    "moduleTitle.add_role": "भूमिका उल्लेख गर्नुहोस",
    "label.user_app_guide_participant": "सहभागीक लागि app प्रयोग गर्ने गाइड",
    "notifications.file_has_been_removed": "फाइल हटाइयो",
    "label.send_message": "",
    "button.select": "छान्नुहोस्",
    "label.reason_of_deletion": "",
    "label.user_guide": "प्रयोगकर्ता पुस्तिका",
    "pageTitle.nao_participants": "नेसनल अफिस - सहभागीहरु",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "अपलोड गर्ने",
    "tasks.approve_item": "स्वीकृत बस्तु",
    "tasks.restore_participant_registration": "",
    "label.awardMode.hybrid": "",
    "table.first_activity_started": "पहिलो क्रियाकलाप सुरु भयो",
    "moduleTitle.dates": "मितिहरू",
    "table.no_results": "नतिजा छैन",
    "states.registration_approval": "दर्ता स्वीकृत",
    "table.breakdown_of_hours": "घण्टा छुट्याउनु होस्",
    "pageTitle.tasks_registration": "सहभागी दर्ता",
    "button.create_new": "नयाँ सिर्जना गर्नुहोस",
    "sidebar.todolist": "गर्नुपर्ने कुराहरु",
    "label.active_participants": "सक्रिय सहभागीहरु",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "संसोधित कार्य",
    "organisation.change_organisation_state": "",
    "moduleTitle.roles": "",
    "label.no_config_key_available": "",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "अफिस ले प्रमाणित गरेको छ",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "मिनेट",
    "label.last_activity": "अन्तिम क्रियाकलाप",
    "sidebar.user_guide": "प्रयोगकर्ता पुस्तिका",
    "label.trained_award_leader": "तालिम प्राप्त अवार्ड लिडर",
    "table.progress": "प्रकिया",
    "table.suboperating_authorities": "सह संचालन निकाय",
    "activity.cannot_edit_activity_offline": "",
    "label.user_does_not_have_permissions": "तपाईंलाई <strong>{user}</strong> हेर्ने अनुमति छैन ।",
    "notifications.assessor_has_been_approved": "",
    "route.activity_approval": "क्रियाकलाप अनुमोदन",
    "moduleTitle.role": "भूमिका",
    "button.run": "जारी",
    "label.to": "",
    "notifications.file_has_been_updated": "फाइल अपलोड भयो",
    "moduleTitle.edit_coordinator": "",
    "notifications.authorization_code_is_no_longer_valid": "आधिकारिक कोड अब मान्य हुदैन ।",
    "button.reject": "संशोधन गर्नुहोस",
    "label.label.participant_status": "सहभागीको स्थिति",
    "award.gold_level": "गोल्ड तह",
    "sidebar.variables": "चरहरु",
    "parentalConsent.checkbox_copy": "म  {firstName} {lastName} को अभिभाबक हो भनि पुष्टि गर्दछु, उ/ उनिलाई अवार्ड लिडरको निगरानीमा {organisationName}  मार्फत अवार्डमा सहभागी हुन अनुमति प्रदान गर्दछु साथै माथि  उल्लेख गरेका एबं अवार्ड संचालकको वेबसाइटमा उल्लेख आबस्यकता , मूल्य , मान्यताहरु मैले पढे र बुझे पनि, ति सबै कुरा म स्वीकार गर्दछु ।",
    "button.go_to_dashboard": "ड्यासबोर्डमा जानुहोस",
    "button.add_option": "विकल्प थप्नुहोस ",
    "label.is_completed": "पुरा भयो",
    "pageTitle.award_units": "अवार्ड युनिट ",
    "states.completed": "पुरा भयो",
    "button.adventurous_journey_template_settings": "साहसिक यात्राको टेम्प्लेट सम्बधि सेटिंग",
    "label.system_rights": "सिस्टमको अधिकार",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "लग इन",
    "label.name_of_the_unit": "इकाईको नाम",
    "button.send": "पठाउनुहोस",
    "award.ajs": "साहसिक यात्राहरु",
    "meta.payments_expired": "भुक्तानी - समय सकियो",
    "label.age": "उमेर",
    "notifications.payment_info_updated": "भुक्तानीको जानकारी अपडेट भयो ।",
    "table.is_completed": "पुरा भयो",
    "table.invited_by": "",
    "route.files": "",
    "route.assessors": "",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "मेरा सहभागीहरु",
    "label.change_leader_status": "",
    "moduleTitle.parent_consent_form": "अभिभाबकको स्वीकृतिको  लागि आबेदन फारम",
    "notifications.authorization_contact_has_been_set": "आधिकारिक सम्पर्क तय भयो",
    "button.close": "बन्द गर्नुहोस",
    "label.independent_country": "स्वतन्त्र राष्ट्र",
    "notifications.aj_preparation_training_has_been_returned": "साहसिक यात्राको तयारी र तालिम संसोधन भयो।",
    "route.history_log": "इतिहासको लग",
    "participant.account_settings": "खाता सम्बन्धि सेटिंगहरु",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "फाइल को url निश्चित गरिएको छैन",
    "notifications.award_unit_has_been_removed": "",
    "table.parent": "अभिभाबक",
    "label.mode_of_transport": "यातायातको किसिम",
    "label.parental_consent_email_info": "",
    "label.current_award": "तत्कालको अवार्ड",
    "table.action": "कार्य",
    "pageTitle.suboperating_authorities": "सह संचालक अख्तियार प्राप्त संस्था",
    "notifications.award_leader_has_been_assigned": "अवार्ड लिडर तोकिएको छ ।",
    "tabs.sign_offs_locally": "स्थानीय स्तरमा  साइन अफ भयो",
    "Activity log has been restored": "notification.log पुन स्थापित गरिएको छ ",
    "sidebar.naos": "NAO हरु",
    "tabs.aj_templates": "साहसिक यात्राको टेम्पलेट",
    "notifications.logging_out": "लगइन आउट ....",
    "label.update_label": "",
    "button.organisation_settings": "",
    "tabs.independent_award_centers": "स्वतन्त्र अवार्ड युनिट ",
    "label.current": "",
    "table.location": "स्थान",
    "button.search": "खोज्न्नुहोस",
    "notifications.aj_preparation_training_has_been_approved": "साहसिक यात्राको तयारि र तालिम स्वीकृत गरियो ।",
    "route.participants": "सहभागीहरु",
    "label.other_location_information": "अन्य स्थानको सुचनाहरु",
    "label.number_of_records": "",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "५. अवार्ड कार्यक्रममा  सहभागी हुदा, यात्रा गर्दा सहभागीको तर्फबाट दुर्घटना , चोटपटक बिरामी वा मृत्यु नै हुनसक्ने अबस्थामा पनि हस्पिटलको सम्पूर्ण खर्च सहभागी आफैले बेहोर्ने स्वीकारोक्ति गर्दछु ।",
    "label.nationality": "राष्ट्रियता",
    "states.approval": "अनुमोदन",
    "notifications.something_went_wrong": "केहि समस्या छ",
    "aj.practice": "अभ्यास",
    "label.addressLine2": "थप ठेगाना",
    "label.please_leave_a_note": "कृपया नोट लेख्नुहोस ।",
    "placeholder.select": "छान्नुहोस्",
    "label.observations": "अबलोकन/ अनुभबहरु",
    "label.aim": "लक्ष",
    "label.addressLine1": "ठेगाना",
    "roles.aj_instructor": "",
    "meta.payments_waiting": "भुक्तानी - पर्खाइमा",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "प्रशिक्षक",
    "moduleTitle.remove_customization_and_reset": "",
    "notifications.participant_registration_has_been_restored": "",
    "organisation.change_award_unit_mode": "",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "सहभागीलाई हटाइयो ।",
    "label.language_settings": "भाषाको सेटिंग",
    "notifications.event_has_been_approved": "कार्य स्वीकृत भयो ।",
    "label.password": "पासवोर्ड",
    "label.text": "सब्द ",
    "table.observations": "अवलोकनहरु",
    "notifications.participant_has_been_created": "सहभागी  सिर्जना गरियो ।",
    "table.note_for_al": "अवार्ड लिडरको लागि नोट",
    "label.payment_confirmed": "भुक्तानी पुष्टि भयो",
    "label.previous_completed_award_level": "अघिल्लो तह (ORB होइन )",
    "pageTitle.new_aj_event": "साहसिक यात्राका  नया कार्यक्रमहरु",
    "label.backend": "",
    "label.relationship_to_participant": "सहभागीसंग सम्बन्ध",
    "award.physical_recreation": "शारीरिक मनोरञ्जन",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "निरीक्षकले रिपोर्ट स्वीकार गर्नुभएन",
    "label.supervisor_report": "पर्यबेक्षकको रिपोर्ट",
    "table.role": "भूमिका",
    "route.user_guide_web_nao": "प्रयोगकर्ता वेब पुस्तिका - NAO",
    "label.page_not_found": "४०४ - पेज भेटिएन",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "फाइल अपलोड भयो",
    "moduleTitle.address": "ठेगाना",
    "moduleTitle.lead_coordinator": "",
    "pageTitle.login": "लग इन",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "आबासिय परियोजना तय गरियो",
    "moduleTitle.award_unit": "अवार्ड युनिट",
    "button.remove_file": "",
    "moduleTitle.billing_address": "बिलिङ ठेगाना",
    "pageTitle.my_aj_events": "मेरो साहसिक यात्राका कार्यक्रमहरु",
    "route.tasks": "कार्यहरु",
    "button.confirm": "पुष्टि गर्नुहोस",
    "label.national_award_authority": "नेसनल अवार्ड अथोरिटी",
    "label.independent_award_centre": "स्वतन्त्र अवार्ड सेन्टर",
    "award.generate_award_report": "रिपोर्ट तयार गर्नुहोस ",
    "route.my_region_office_customization": "My Regional Office - मिलाइएको ",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "पासवोर्ड परिबर्तनको अनुरोध पठाईएको छ ।",
    "tabs.detail": "सम्पूर्ण विवरण",
    "participant.change_participant_status": "सहभागी को तह परिवर्तन गर्नुहोस ",
    "table.key": "",
    "label.find_address": "ठेगाना पत्ता लगाउनुहोस ।",
    "notifications.assessor_has_been_rejected": "",
    "label.transfer_participants": "सहभागी स्थानान्तरण",
    "button.continue_to_payment_gateway": "भुक्तानी गर्ने बाटो रोज्नुहोस ",
    "notifications.participant_registration_has_been_removed": "",
    "moduleTitle.page_not_found": "४०४ - पेज भेटिएन",
    "route.adventurous_journeys": "सहासिक यात्रा",
    "states.registration_assessment": "रजिस्ट्रेसन प्रमाणित हुदै छ ।",
    "heading.change_award_unit_mode": "",
    "label.user_guide_web_nao": "प्रयोगकर्ता वेब पुस्तिका - NAO",
    "tabs.silver_level": "सिल्भर तह",
    "table.paid_by": "भुक्तानी गर्ने",
    "label.your_report_has_been_successfully_sent": "तपाइको रिपोर्ट सफलतापुर्बक पठाइयो ।",
    "sidebar.my_organization": "मेरो संस्था",
    "pageTitle.participants": "सहभागीहरु",
    "notifications.preparation_training_has_been_updated": "तयारि र तालिम अपडेट गरियो",
    "moduleTitle.server_is_unreachable": "",
    "label.last_activity_date": "",
    "award.bronze_level": "ब्रोंज तह",
    "moduleTitle.award_units": "",
    "table.completed": "पुरा भयो",
    "moduleTitle.revise_message": "संदेश प्राप्त",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "",
    "button.change_password": "पासवोर्ड परिबर्तन गर्नुहोस",
    "label.nao_price": "NAO शुल्क",
    "label.payment_state": "भुक्तानीको अवस्था",
    "label.wwc_expired": "",
    "label.award_office_signoff_date": "",
    "label.award_unit": "अवार्ड इकाई",
    "award.gold_level_short": "गोल्ड",
    "moduleTitle.other_info": "अन्य जानकारी",
    "table.note": "नोट",
    "label.search_by_email_first_or_last": "इमेल, पहिलो वा अन्तिम नामको आधारमा खोज्नुहोस",
    "tabs.history": "इतिहास",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "सहभागी तोकिएको छैन",
    "table.main_award_leader": "मुख्य अवार्ड लिडर",
    "parentalConsent.i_as_the_parent": "३. मलाइ थाहा छ कि निश्चित क्रियाकलाप धेरै जोखिमपूर्ण  छन् या हुन् सक्छन र यस्ता जोखिमपूर्ण क्रियाकलापहरुको लागि  भनेर अवार्ड संचालकले बिमा गर्नुभएको  छैन।  मलाइ थाहा छ एसको  सम्पूर्ण  जिम्मेवारी सहभागी आफैको हुनेछ ।",
    "label.state": "अवस्ता",
    "notifications.award_leader_has_been_removed": "",
    "tabs.organization_detail": "संस्थाको सम्पूर्ण विवरण",
    "table.operating_authorities": "संचालक निकाय",
    "label.available_labels": "",
    "modal.select": "छान्नुहोस",
    "tabs.expired_payments": "भुक्तानी समय सकिएको छ",
    "moduleTitle.note_for_al": "लिडरको लागि नोट",
    "moduleTitle.confirm": "पुष्टि गर्नुहोस",
    "notification.new_activity_added": "कुनै पनि क्रियाकलाप थपिएको छैन ।",
    "notifications.award_leader_has_been_moved": "अवार्ड लिडरलाई  सारिएको छ ।",
    "label.award_mode": "",
    "label.phone": "फोन",
    "notifications.organization_has_been_updated": "संस्था अपडेट गरिएको छ ।",
    "moduleTitle.assessor": "निरीक्षक",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "अभिभाबकको स्वीकृति",
    "label.date_of_delivery": "बुझाइएको मिति",
    "sidebar.assessors": "",
    "label.journey_activity": "यात्राको क्रियाकलाप",
    "award.inactive_award": "निस्क्रिय अवार्ड ",
    "label.end_date": "अन्तिम मिति",
    "label.orb_testing": "",
    "label.no_activities": "कुनै क्रियाकलाप छैन ",
    "moduleTitle.please_confirm": "निश्चित गर्नुहोस ",
    "button.login_with_another_account": "नयाँ खाताबाट लग इन गर्नुहोस ।",
    "tasks.reject_registration": "दर्ता संसोधन",
    "label.submitted_after_date": "",
    "label.update_translations_successful": "",
    "button.assign_leader": "नियुक्त भएको लिडर",
    "table.already_running": "पहिल्यै सुरु भयो",
    "label.no": "होइन",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "",
    "label.my_experience": "मेरो अनुभब",
    "notifications.adventurous_journey_has_been_approved": "साहसिक यात्रा स्वीकृत भयो ।",
    "pageTitle.mro_detail": "मेरो रिजनल अफिस  - विस्तृत विवरण",
    "moduleTitle.nao_specific_info": "NAO बिशेष जानकारी",
    "label.preparing_document_for_import": "",
    "tasks.observations": "अबलोकन / अनुभबहरू",
    "notifications.confirmation_email_has_been_sent": "पुष्टि गर्ने इमेल पठाइयो",
    "button.restore": "पुन स्ताफित",
    "label.importing_file": "",
    "label.or_dont_agree": "अथवा स्वीकार छैन ? तपाईंले",
    "moduleTitle.award_leader": "अवार्ड लिडर",
    "label.me": "(म)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "टेबल निर्यात गर्नुहोस ",
    "organisation.move_award_unit": "",
    "label.file_category": "",
    "notifications.connecting_to_server": "सर्भरसंग सम्बन्ध गासिदै",
    "parentalConsent.i_understand_that_a_and_b": "११.मलाई थाहा छ कि सहभागी संग सवारी चालक अनुमती पत्र र उचित तेश्रो पक्ष बिमा नभएसम्म सहभागी  <br /> a. ले कुनै पनि सवारी साधन अवार्ड क्रियाकलापको लागि चलाउन र सहभागिलाई यताउता लैजान पाउने छैन ।साथै अवार्डसंग सम्बन्धित नभयका व्यक्तिसंग सहभागीले अवार्ड कार्यक्रमका लागि यात्रा गर्न पाइने छैन साथै  यात्रा गराउने व्यक्तिसंग अनिबार्य रुपमा आधिकारिक अनुमति पत्र हुन जरुरि छ ।",
    "table.reason": "",
    "pageTitle.contacts": "सम्पर्क",
    "states.award_leader_approval": "अवार्ड लिडरको अनुमोदन",
    "meta.payments": "भुक्तानी",
    "label.suboperating_authority": "सह संचालक अख्तियार प्राप्त संस्था",
    "route.my_region_office": "मेरो रिजनल कार्यालय",
    "states.registration_not_approved": "दर्ता स्वीकृत भएन",
    "label.direct_entrant": "सिधा सहभागी",
    "tabs.all_participants": "सबै सहभागी",
    "tabs.payment": "भुक्तानी",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "नयाँ  पासवोर्ड दोहोर्याउनु होस्",
    "label.other_roles": "",
    "logs.hours": "घण्टाहरु",
    "notifications.spreadsheet_has_been_imported_successfully": "",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "व्यक्तिगत विवरण",
    "label.bulk_action_emailing": "",
    "route.my_events": "मेरो क्रियाकलापहरु",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "यसमा  क्यापिटल र स्मल लेटर प्रयोग गर्नुहोस",
    "tabs.removed_participant_registrations": "",
    "sidebar.mynao": "मेरो NAO",
    "tabs.office_details": "कार्यालयको सम्पर्क ठेगाना",
    "label.major": "मुख्य",
    "tabs.documents": "डकुमेन्टहरु",
    "label.new_password": "नयाँ  पासवोर्ड",
    "sidebar.adventure_journey": "साहासिक यात्रा",
    "pageTitle.customizations": "आनुकुलन",
    "moduleTitle.assessor_report": "{role} रिपोर्ट",
    "label.registration_date": "दर्ता मिति",
    "notifications.training_has_been_added": "तालिम थप गरियो ।",
    "aj.qualifying": "क्वालिफाई",
    "moduleTitle.you_have_been_logged_out_session_terminated": "",
    "award.service": "सेवा",
    "notifications.rp_state_has_been_changed": "आबासिय परियोजनाको अबस्था परिबर्तन भयो",
    "label.ctest_access": "",
    "table.created": "सिर्जना भयो",
    "tasks.revise_task": "संसोधित कार्य",
    "button.assign": "नियुक्त",
    "button.return": "पुनरावृति ",
    "table.status": "स्थिति",
    "button.restore_activity": "गतिविधि पुनर्स्थापना",
    "tabs.new_aj_event": "साहसिक यात्राको नयाँ गतिबिधि",
    "roles.if_staff_viewer": "",
    "notifications.new_template_has_been_created": "नयाँ टेम्पलेट सिर्जना गरिएको छ ।",
    "global.something_went_wrong": "केहि समस्या छ ।",
    "table.expire_day": "",
    "tabs.history_log": "लग को इतिहास",
    "label.form_of_payment": "भुक्तानीको लागि आबेदन",
    "button.add_training": "तालिम थप्नुहोस",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "मेरो  योग्यता",
    "button.add_new_profile_question": "नयाँ प्रोफाइल प्रस्न थप्नुहोस ",
    "table.operating_authority": "",
    "table.aim": "लक्ष",
    "table.awards": "अवार्डहरु",
    "participant.deactivate_account": "खाता बन्द गर्नुहोस",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "मिति",
    "tasks.would_you_like_to_delete": "के तपाई सहभागीलाई हटाउन चाहानुहुन्छ ?",
    "notifications.configuration_value_has_been_updated": "कंफिगरेशन अपडेट भएको छ",
    "ajTemplates.fill_from_template": "टेम्पलेट बाट भर्नुहोस",
    "contact.send_test_email": "",
    "moduleTitle.aj_preparation_and_training": "साहसिक यात्राको तयारि र तालिम",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "अभिभाबकको&#39;s फोन नम्बर",
    "label.nao_regulations": "",
    "award.skills": "सीपहरु",
    "label.reject_application": "यो निबेदन अस्वीकार गर्नुहोस ।",
    "leader.delete_account": "",
    "table.assign": "तोक्नु",
    "roles.aj_supervisor": "साहसिक यात्राको पर्यबेक्षक",
    "label.logout": "लग आउट",
    "moduleTitle.award_leader_edit": "",
    "moduleTitle.training": "तालिम",
    "notifications.coordinator_has_been_removed": "संयोजक हटाइएको छ",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "मुख्य अवार्ड  लिडर/ संयोजक",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "तयारी",
    "table.delete": "मेटाउनुहोस",
    "label.safeguarding_policy": "",
    "sidebar.reports": "रिपोर्टहरु",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "संचालक अख्तियार प्राप्त संस्था",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "पुष्टि भयो",
    "notifications.invitation_has_been_sent": "निमंत्रणा पठाईएको छ ।",
    "pageTitle.independent_countries": "स्वतन्त्र देशहरु",
    "label.assessors_email": "",
    "tasks.approve_assessor_registration": "",
    "table.award_duration": "अवार्डको अबधि",
    "notifications.organization_has_been_moved": "",
    "pageTitle.nao_payment": "नेसनल अफिस - भुक्तानी",
    "participant.history_log": "इतिहास लग",
    "label.rejected_with_note": "",
    "label.already_running": "अगाडी नै चलिरहेको छ",
    "button.continue": "",
    "award.no_data_to_show": "देखाउनको लागि कुनै तथ्य छैन",
    "participant.send_email_invitation_again_question": "फेरी इमेल मार्फत निमंत्रणा पठाउनु पर्ने हो  ?",
    "label.reason_for_changing_assessor": "",
    "button.delete": "मेटाउनुहोस",
    "moduleTitle.requirements_and_conditions": "आबस्यकताहरु र अबस्थाहरु",
    "roles.leader": "लिडर",
    "label.if_download_doesnt": "",
    "dashboard.your_todo_list": "तपाइले गर्नुपर्ने कामहरु",
    "notifications.award_unit_has_been_returned": "अवार्ड इकाई संसोधन भएको छ ।",
    "moduleTitle.participant_activities": "सहभागी क्रियाकलाप",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "सक्रिय लिडरहरु",
    "aj.preparation": "तयारी",
    "button.change_state": "अबस्था परिबर्तन भयो",
    "label.current_password": "अहिलेको पासवोर्ड",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "ठेगाना सम्बन्धि सेटिंगहरु",
    "button.remove_photo": "फोटो हटाउनु होस्",
    "notifications.activity_has_been_setup": "क्रियाकलाप तय भयो",
    "errors.must_be_more_than": "{limit} भन्दा बढी हुनु पर्ने",
    "table.goal": "लक्ष",
    "notifications.coordinator_has_been_set": "संयोजक तोकिएको छ",
    "label.cc": "",
    "label.duration": "अबधि",
    "table.actions": "कार्यहरु",
    "participant.send_email_invitation_again": "इमेल मार्फत निमंत्रणा फेरी गर्नु पर्ने हो ?",
    "moduleTitle.would_you_like_to_remove_participant": "के तपाइँ सहभागी #{value} लाई हटाउन चाहानुहुन्छ ?",
    "parentalConsent.i_authorise_employees": "४. कुनै दुर्घटना , चोटपटक बिरामी वा सहभागीको मृत्यु भएको अबस्थामा रोजगार ब्यक्ति , अफिस , अवार्डको एजेन्ट वा सहभागी अन्य व्यक्तिहरुलाई आबस्यक उपचार गर्ने ब्यबस्था मिलाउनका लागि अनुमति दिन्छु ।",
    "button.reload_page": "पेज पुन लोड गर्नुहोस",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "इमेल",
    "label.new_goal": "नया लक्ष",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "इमेल गलत भयो",
    "pageTitle.new_contact": "नयाँ  सम्पर्क",
    "sidebar.gops": "",
    "button.manage_participants": "सहभागीलाई ब्यबस्थापन गर्नुहोस ",
    "errors.invalid_phone_format": "फोन नम्बर गलत भयो",
    "notifications.login_details_have_been_changed": "लगइन सम्बन्धि  बिवरण परिवर्तन भयो",
    "moduleTitle.participant_logs": "सहभागी लग ",
    "label.save": "सुरक्षित गर्नुहोस",
    "label.frequently_asked_questions": "",
    "label.city": "सहर",
    "notifications.configuration_value_has_been_reset": "",
    "states.office_sign_off": "अवार्ड अफिस बाट प्रमाणित भयो",
    "button.save": "सेभ गर्नुहोस",
    "button.import_data_from_selected_file": "",
    "parentalConsent.i_understand_that_the_participant_cannot": "९. कुनै पनि स्वयमसेवकले आबस्यक विवरण अवार्ड युनिटमा नबुझाएसम्म निर्देशन दिन मुल्यांकन गर्न र निरिक्षण गर्न पाइने छैन साथै उक्त स्वयमसेबक अवार्ड इकाईको स्टाफ हुने छैन र सहभागी आफैले आफैलाई सन्तुष्ट नबनाएसम्म अवार्डको कुनै पनि खण्ड सुरु गर्न पाईने छैन भन्ने व्यहोरा मैले बुझेको छु ।",
    "pageTitle.apiKeys": "",
    "label.international_region": "अन्तर्राष्ट्रिय क्षेत्र ",
    "tabs.levels": "तहहरु",
    "tabs.additional_files": "",
    "label.continuation_level": "निरन्तर लेबल",
    "table.adventurous_journey_detail": "साहसिक यात्राको विवरण",
    "button.set": "तय गर्नुहोस",
    "label.i_certify_that_as_the_assessor": "सहभागीले यो क्रियाकलापका लागि आबस्यक सबै नीति नियमहरु {role} पुरा गरेको निस्चय गर्दछु ।",
    "table.coordinator": "संयोजक",
    "participant.send_confirmation_email_again": "पुष्टि गर्ने इमेल पुन पठाउनु पर्ने हो ?",
    "table.report": "रिपोर्ट",
    "label.update_translations_results": "",
    "table.observation_note": "अबलोकन नोट",
    "label.view_more": "",
    "notifications.payment_link_has_been_reset": "भुक्तानी गर्ने लिंक पुन सेट गरिएको छ",
    "table.type": "प्रकार",
    "moduleTitle.updateConfigurationKey": "कन्फिगरेशन कि अपडेट गर्नुहोस",
    "sidebar.independent_award_centers": "स्वतन्त्र अवार्ड सेन्टरहरु",
    "table.activity_type": "क्रियाकलापको प्रकार",
    "label.awardMode.online": "",
    "table.data_state": "",
    "button.generate_report": "रिपोर्ट तयार गर्नुहोस ",
    "moduleTitle.assessed_by_award_leader": "अवार्ड लिडरबाट मूल्यांकन गरिएको छ ।",
    "table.child_protection_number": "",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "अवार्डको स्थति",
    "moduleTitle.overview": "विस्तृत सर्वेक्षण",
    "table.aj_detail": "साहसिक यात्राको विवरण",
    "pageTitle.tasks_activity_approvals": "क्रियाकलाप अनुमोदन",
    "label.section": "",
    "route.history": "इतिहास",
    "route.event_participants": "कार्यक्रम सहभागी",
    "participant.account_detail": "खाता सम्बन्धि सेटिंगहरु",
    "route.dashboard": "ड्यासबोर्ड",
    "table.payments": "भुक्तानीहरु",
    "pageTitle.profile": "प्रोफाइल",
    "organisation.remove_organisation": "",
    "pageTitle.my_organization": "मेरो संस्था",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "ड्युक",
    "table.qualifying": "Qualifying",
    "button.upload": "अपलोड",
    "button.resend": "पुन पठाइएको छ ",
    "label.filename": "",
    "label.change_parental_consent": "",
    "button.cancel": "रद्द",
    "label.aply_to_all_langs": "",
    "route.customization": "अनुकूल",
    "errors.minimal_duration_is": "कम्तिमा ३० मिनेटको अबधि",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "सहभागीको स्थिति",
    "award.bronze_level_short": "ब्रोंज",
    "label.phone_type": "फोनको प्रकार",
    "global.night": "रात",
    "button.adventurous_journey_settings": "साहासिक यात्रा सबन्धि सेटिंगहरु",
    "participant.leader_must_be_selected": "लिडर चयन गर्न आबस्यक",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "प्रयोगकर्ताबाट तयारी र तालिम थपियो",
    "table.approve": "अनुमोदन गर्नुहोस",
    "label.role_in_organisation": "सस्थामा के भूमिका  छ ?",
    "states.finished": "पुरा भयो",
    "label.created": "सिर्जना भयो ।",
    "button.back_to_home": "मुख्य पृष्ठमा फर्कनुहोस",
    "label.options": "विकल्प ",
    "contact.next_level_invitation": "",
    "moduleTitle.activity_detail": "क्रियाकापको विवरण",
    "route.section_signoff": "यो भाग प्रमाणित भयो",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "सम्पर्क सेटिंगहरु",
    "label.transation_id": "कारोबार आइडी",
    "notifications.activity_has_been_updated": "क्रियाकलाप अद्यावधिक गरिएको छ ।",
    "sidebar.awards": "अवार्डहरु",
    "parentalConsent.images_consent": "अविभावक को नाता ले अवार्ड प्रचार प्रसारका लागि फोटोहरु प्रयोग गर्नका लागि अनुमति दिन्छु ।",
    "participant.would_you_like_to_delete": "के तपाइँ यो खाता मेटाउन चाहानुहुन्छ",
    "roles.user": "प्रयोगकर्ता",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "नतिजा भेटिएन",
    "moduleTitle.address_line_2": "अस्थाई  ठेगाना ",
    "states.awaiting_office_sign_off": "अवार्ड अफिस बाट प्रमाणित हुन बाँकि छ",
    "moduleTitle.export": "निर्यात ",
    "moduleTitle.address_line_1": "स्थाई ठेगाना",
    "notifications.participant_has_been_assigned": "सहभागी तय  गरिसकीएको छ।",
    "roles.viewer": "अबलोकन कर्ता",
    "label.participants_total": "जम्मा सहभागी",
    "errors.auth_code_is_no_longer_valid": "",
    "label.file_is_not_available": "",
    "button.select_template": "टेम्पलेट चयन गर्नुहोस",
    "label.payment": "भुक्तानी",
    "award.silver_level_short": "सिल्भर",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "तपाईंको व्यक्तिगत जानकारी",
    "aj.minimum_date_recommendation": "सहासिक यात्रा को लागि {name} समय सिफारिस गरिएको छ ।",
    "label.date_of_payment": "भुक्तानी गरियको मिति",
    "button.view": "हेर्नुहोस",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "सहभागीहरु तय गर्नुहोस ",
    "roles.assessor": "निरीक्षक",
    "moduleTitle.coordinator_settings": "",
    "label.parent_relationship": "अभिभाबक&#39;s सम्बन्ध",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "सह संचालक अख्तियार प्राप्त संस्था",
    "route.award": "अवार्ड",
    "label.no_roles": "कुनै भूमिका छैन",
    "table.files": "फाइलहरु",
    "aj.minimum_date_requirements": "सहासिक यात्रा र {name} का लागि न्युनतम आबस्यक समय",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "",
    "moduleTitle.other_coordinators": "",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "अवार्ड दर्तालाई स्वीकृत गर्नुहोस",
    "participant.invite_participant_to_next_level": "",
    "label.twitter": "टुइटर",
    "pageTitle.awards": "अवार्डहरु",
    "warning.award_marked_as_paid": "",
    "table.edit": "पुनरावलोकन",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "इन्टरनेसनल",
    "moduleTitle.after_assigning_a_role_to_yourself": "",
    "label.transaction_id": "कारोबार ID",
    "table.suboperating_authority": "",
    "label.participant_survey": "",
    "label.created_by": "सिर्जना गर्ने",
    "button.send_confirmation_email_again_question": "कन्फरमेसन इमेल फेरी पठाउनुहोस ।",
    "label.email_help_award_leader_email": "",
    "label.name": "नाम",
    "tabs.gold_level": "गोल्ड तह",
    "pageTitle.award_documents": "अवार्डका डकुमेन्टहरु",
    "label.online_payments": "अनलाइन भुक्तानी",
    "label.child_protection_number": "",
    "participant.send_password_recovery_email": "फेरी पासवोर्ड प्राप्त गर्न इमेल पठाउनु पर्ने हो ?",
    "notifications.new_log_has_been_added": "नयाँ लग थपिएको छ ।",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "सस्थाको नाम",
    "pageTitle.my_organization_templates": "मेरो संस्था  - टेम्प्ल्पेट्सहरु",
    "pageTitle.award_leaders": "अवार्ड लिडरहरु",
    "label.status": "",
    "label.street": "टोल",
    "roles.if_staff_superuser": "",
    "table.licence_holder": "लाइसेन्स लिने",
    "label.created_at": "सिर्जना गर्ने",
    "table.section": "खण्ड",
    "table.system_rights": "सिस्टमको आधिकार",
    "label.iac_type": "IAC को प्रकार ",
    "label.other": "अन्य",
    "moduleTitle.login": "लगइन",
    "label.no_data_to_show": "देखाउनको लागि केहि छैन",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "यदी सहासिक यात्रा मा सहभागीलाई पठाइसकेको छ भने तपाईं ले अवार्ड को लेवेल परिवर्तन गर्न सक्नुहुन्न",
    "tabs.waiting_payments": "भुक्तानी पर्खाइमा",
    "global.supervisor": "पर्यबेक्षक",
    "notifications.new_role_has_been_added": "नया भूमिका थप गरियो ।",
    "award.silver_level": "सिल्भर तह",
    "heading.change_awards_mode": "",
    "button.save_changes": "परिबर्तन सुरक्षित गर्नुहोस",
    "organisation.would_you_like_to_move_award_unit": "",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "मेरो रिजनल अफिस  - सम्पूर्ण विवरण ",
    "table.started_at": "सुरु",
    "parentalConsent.i_consent_to_the_award_unit": "२. म अवार्ड युनिटका  ब्यक्तिहरु , भोलिन्टियरहरु  जो अवार्ड संग सम्बधित हुनुहुन्छ  या सहयोग गरिरहनुभएको छ साथै भाडा तिरीएका सवारी चालकहरु, अवार्ड क्रियाकलापको लागि  यात्रा गराउने व्यक्तिहरु वा अवार्ड कार्यक्रमा आदिमा सहभागी हुन वा गराउन अनुमति दिन्छु ।मलाई  थाहा छ कि अवार्ड इकाईले मलाई पहिल्यै यस्ता यात्राको बारेमा जानकारी गराउँछ।",
    "logs.minutes": "मिनेट",
    "label.total_participants": "जम्मा सहभागीहरु",
    "moduleTitle.contact_info": "सम्पर्क जानकारी",
    "table.payment_link": "भुक्तानी लिंक",
    "errors.please_contact_your_local_award_staff": ""
}